import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { faBell } from '@fortawesome/pro-solid-svg-icons';

import ClickableIcon from 'components/clickable_icon';
import Tooltip from 'components/tooltip';
import Reminders from './reminders';

import './styles.scss';

export default function ReminderInfo({ referenceDate, reminders, onClick }) {
  const pendingReminders = [];
  const sentReminders = [];
  for (const reminder of reminders) {
    if (reminder.sent) {
      sentReminders.push(reminder);
    } else {
      pendingReminders.push(reminder);
    }
  }

  const content = [];
  if (pendingReminders.length > 0) {
    content.push(
      <Reminders
        header="Upcoming reminders"
        key="pending"
        referenceDate={referenceDate}
        reminders={pendingReminders}
      />
    );
  }

  if (sentReminders.length > 0) {
    content.push(
      <Reminders
        className={classNames({ 'mt-2': pendingReminders.length > 0 })}
        header="Sent reminders"
        key="sent"
        referenceDate={referenceDate}
        reminders={sentReminders}
      />
    );
  }

  return (
    <Tooltip content={content}>
      <div className="reminders-info" onClick={onClick}>
        <ClickableIcon icon={faBell} />
      </div>
    </Tooltip>
  );
}

ReminderInfo.propTypes = {
  referenceDate: PropTypes.string,
  reminders: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    sent: PropTypes.bool,
    sentAt: PropTypes.string,
  })).isRequired,
  onClick: PropTypes.func,
};
